import React from "react"
import PropTypes from "prop-types"

import styles from "./TestDriveBookingFlow.module.sass"

const TestDriveFormSummary = ({
  tradeInValuation,
  department,
  showHeadline,
  translations,
  bookingTime,
}) => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        {showHeadline && (
          <React.Fragment>
            <h1>{translations.headline}</h1>
            <h3 className={styles.subheadline}>{translations.subheadline}</h3>
          </React.Fragment>
        )}
        <div className={`${styles.bookingDetails} car-summary`}>
          <h3>{translations.details_of_your_reservation}</h3>
          <ul>
            <li>
              <span className={styles.bookingDetail__right}>
                {translations.labels.date_and_time}
              </span>
              <span className={styles.bookingDetail__left}>{bookingTime}</span>
            </li>
            <li>
              <span className={styles.bookingDetail__right}>
                {translations.labels.name}
              </span>
              <span className={styles.bookingDetail__left}>
                {tradeInValuation.buyer_name}
              </span>
            </li>
            <li>
              <span className={styles.bookingDetail__right}>
                {translations.labels.phone_number}
              </span>
              <span className={styles.bookingDetail__left}>
                {tradeInValuation.buyer_phone_number}
              </span>
            </li>
            <li>
              <span className={styles.bookingDetail__right}>
                {translations.labels.email}
              </span>
              <span className={styles.bookingDetail__left}>
                {tradeInValuation.buyer_email}
              </span>
            </li>
            {department?.length ? (
              <li>
                <span className={styles.bookingDetail__right}>
                  {translations.labels.department}
                </span>
                <span className={styles.bookingDetail__left}>
                  {department[0].label}
                </span>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </React.Fragment>
  )
}

TestDriveFormSummary.propTypes = {
  department: PropTypes.array,
  tradeInValuation: PropTypes.object,
  showHeadline: PropTypes.bool,
  translations: PropTypes.object,
  bookingTime: PropTypes.string,
}

export default TestDriveFormSummary
